var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "id_2" }, [
    _c("div", { staticClass: "o_div" }, [
      _c("div", { staticClass: "top clear" }, [
        _vm.data.src
          ? _c("div", { staticClass: "img_box fl" }, [
              _c("img", { attrs: { src: _vm.data.src } })
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", {
          staticClass: "title bold fl",
          domProps: { innerHTML: _vm._s(_vm.data.title) }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "concent" }, [
        _c("div", {
          staticClass: "text",
          domProps: { innerHTML: _vm._s(_vm.data.text) }
        })
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-80e8c5ba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-80e8c5ba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/module/course/public/id_2.vue
// module id = null
// module chunks = 